import React from 'react';
import { useNotification } from '../contexts/NotificationContext';
import { XMarkIcon } from '../icons';

const NotificationContainer = () => {
  const { notifications, removeNotification } = useNotification();

  const getNotificationStyles = (type, color) => {
    const baseStyles = "relative flex items-start p-4 mb-3 rounded-lg shadow-lg border-l-4 transform transition-all duration-300 ease-in-out";
    
    const colorStyles = {
      yellow: "bg-yellow-50 border-yellow-400 text-yellow-800",
      green: "bg-green-50 border-green-400 text-green-800",
      red: "bg-red-50 border-red-400 text-red-800",
      blue: "bg-blue-50 border-blue-400 text-blue-800",
    };

    return `${baseStyles} ${colorStyles[color] || colorStyles.blue}`;
  };

  const getIconStyles = (type, color) => {
    const baseStyles = "flex-shrink-0 w-6 h-6 mr-3 mt-0.5";
    
    const colorStyles = {
      yellow: "text-yellow-600",
      green: "text-green-600",
      red: "text-red-600",
      blue: "text-blue-600",
    };

    return `${baseStyles} ${colorStyles[color] || colorStyles.blue}`;
  };

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50 w-96 max-w-sm">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={getNotificationStyles(notification.type, notification.color)}
          style={{
            animation: 'slideInRight 0.3s ease-out',
          }}
        >
          {/* Close button */}
          <button
            onClick={() => removeNotification(notification.id)}
            className="absolute top-2 right-2 p-1 rounded-full hover:bg-black hover:bg-opacity-10 transition-colors"
          >
            <XMarkIcon className="w-4 h-4" />
          </button>

          {/* Icon */}
          <div className={getIconStyles(notification.type, notification.color)}>
            {notification.icon && (
              <span className="text-lg">{notification.icon}</span>
            )}
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-semibold mb-1">
              {notification.title}
            </h4>
            <p className="text-sm opacity-90">
              {notification.message}
            </p>
            
            {/* Progress indicator for processing notifications */}
            {notification.type === 'processing' && (
              <div className="mt-2">
                <div className="w-full bg-gray-200 rounded-full h-1.5">
                  <div 
                    className="bg-yellow-500 h-1.5 rounded-full animate-pulse"
                    style={{ width: '100%' }}
                  ></div>
                </div>
                <p className="text-xs mt-1 opacity-75">
                  Processing your audio...
                </p>
              </div>
            )}

            {/* Timestamp */}
            <p className="text-xs mt-2 opacity-60">
              {notification.timestamp.toLocaleTimeString()}
            </p>
          </div>
        </div>
      ))}

      {/* CSS Animation */}
      <style jsx>{`
        @keyframes slideInRight {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default NotificationContainer;
